import { useQuery } from "react-query"
import DataService from '../../../config/DataServices'

const { getRequest } = DataService()

export const DepositHistory = ({ page, size, sortOrder, searchText, sortField, type, currency, network }) => {

    return useQuery({
        queryKey: ["transfer-history", page, size, searchText, sortOrder, type, currency, network],
        queryFn: () => {
            return getRequest(`/user-transactions?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&type=${type}&currency=${currency}&network=${network}`)
        }
    })
}
